import { render } from "./form-info.vue?vue&type=template&id=6d620553&ts=true"
import script from "./form-info.vue?vue&type=script&lang=ts"
export * from "./form-info.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__